import { AutogenLayoutPerfAlertDefAdvancedSearch } from "./autogen/AutogenLayoutPerfAlertDefAdvancedSearch";
import { ChangeEvent, LookupModelSearchEvent } from "@mcleod/components";

export class PerfAlertDefAdvancedSearch extends AutogenLayoutPerfAlertDefAdvancedSearch {

    /** This is an event handler for the onChange event of id9. */
    id9OnChange(event: ChangeEvent) {

    }

    /** This is an event handler for the beforeLookupModelSearch event of id11. */
    id11BeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.metric_category = this.id10.text;
    }
}
